export default __webpack_public_path__ + "static/media/insta-colored-icon.832df2d1.svg";